export default {
  COMING: 'coming',
  ONGOING: 'ongoing',
  ENDED: 'ended',
  AVAILABLE: 'available',
};
